export const carouselConfig = {
  dots: true,
  nextArrow: <></>,
  prevArrow: <></>,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  infinite: false,
};
